import { compose } from "redux";
import React, { PureComponent } from "react";
import { blue } from "@material-ui/core/colors";
import { Link, generatePath } from "react-router-dom";

import {
  Grid,
  Button,
  Switch,
  Typography,
  withStyles,
  FormControlLabel,
} from "@material-ui/core";

import { HeaderBase } from "altus-ui-components";

import routePaths from "app/routePaths";

class ViewLayoutModeInfoPanel extends PureComponent {
  render() {
    const {
      viewId,
      classes,
      getView,
      autoSave,
      toggleAutoSave,
      saveViewGroupOrder,
    } = this.props;

    return (
      <HeaderBase
        classes={{
          root: classes.root,
        }}
      >
        <Grid item xs>
          <FormControlLabel
            label={
              <Typography variant="body2" noWrap color="inherit">
                Auto save changes
              </Typography>
            }
            classes={{
              label: classes.formControlLabel,
            }}
            control={<Switch checked={autoSave} onChange={toggleAutoSave} />}
          />
        </Grid>
        <Grid
          xs
          item
          noWrap
          variant="subtitle1"
          component={Typography}
          className={classes.title}
        >
          Drag and drop view groups to customize your view
        </Grid>
        <Grid item xs container justifyContent="flex-end" spacing={1}>
          {!autoSave && (
            <Grid item>
              <Button onClick={getView}>Reset</Button>
            </Grid>
          )}
          <Grid item>
            <Button
              variant="contained"
              component={autoSave ? Link : undefined}
              onClick={autoSave ? undefined : saveViewGroupOrder}
              to={
                autoSave ? generatePath(routePaths.view, { viewId }) : undefined
              }
            >
              {autoSave ? "Close" : "Save"}
            </Button>
          </Grid>
        </Grid>
      </HeaderBase>
    );
  }
}

const styles = theme => ({
  root: {
    top: 0,
    zIndex: 2,
    position: "sticky",
    background: blue[200],
    color: theme.palette.getContrastText(blue[200]),
  },
  title: {
    textAlign: "center",
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default compose(withStyles(styles))(ViewLayoutModeInfoPanel);
